import { useCommonStore } from "@/store/common";
import { setCookie } from "@/utils/cookie";

export const useTheme = () => {
  const showThemeRouterLists = [
    "/futures",
    "/lite-perpetual",
    "/demo-futures",
    "/futures-copy",
    "/spot",
    "/dex",
    "/assets",
  ];
  // 忽略的路由
  const ignoreThemeRouterLists = [
    "/assets/overview/analysis",
    "/assets/spot/analysis",
    "/assets/future/analysis",
    "/assets/future-strategy/analysis",
    '/futures/info', '/futures/rule'
  ]
  // 支持主题切换的路由配置
  const showToggleThemeEnter = computed(() => {
    const path = useRoute().path;
    return showThemeRouterLists.some((item) => path?.includes(item) && !ignoreThemeRouterLists.some(ignore => path.includes(ignore)));
  });

  const showToggleThemeEnterFn = (path: string) => {
    return showThemeRouterLists.some((item) => path?.includes(item) && !ignoreThemeRouterLists.some(ignore => path.includes(ignore)));
  }


  const comm = useCommonStore();
  const toggleTheme = (theme?: "dark" | "light") => {
    const curTheme =
      document.documentElement.className.indexOf("dark") > -1
        ? "dark"
        : "light";
    const newTheme = theme || (curTheme === "dark" ? "light" : "dark");
    document.documentElement.setAttribute("class", newTheme);
    setCookie("c-theme", newTheme);
    localStorage.setItem("isDark", newTheme);
    // 兼容nuxt项目
    localStorage.setItem("theme", newTheme);
    comm.isDark = newTheme;
  };

  const theme = computed(() => {
    return comm.isDark;
  });

  return {
    theme,
    toggleTheme,
    showToggleThemeEnter,
    showToggleThemeEnterFn,
  };
};
